/* @flow */

import * as React from 'react';

import {AccentBorder} from 'shells/accent-border';
import {Card} from 'shells/card';
import {RemoveButton} from 'shells/button';
import {colors} from 'shells/colors';
import {LoadingText} from 'shells/loading-placeholder/loading-text';

import './select-field.css';

type Props = {
    name: string,
    onRemove: () => void,
    isLoading?: boolean,
};

export function SelectedFieldCard(props: Props) {
    return (
        <div styleName='select-card'>
            <Card hasBorder={true}>
                <AccentBorder location='left' color={colors.lead}>
                    <div styleName='input-container'>
                        {props.isLoading ? (
                            <LoadingText height={27} />
                        ) : (
                            <>
                                {props.name}
                                <RemoveButton onClick={props.onRemove} size={12} />
                            </>
                        )}
                    </div>
                </AccentBorder>
            </Card>
        </div>
    );
}
